import type ChargebeeAddon from './ChargebeeAddon'
import { Pricing, PricingType } from './Pricing'

const LATAM_COUNTRIES = ['ar', 'co', 'mx', 'cl']
const REGION_COUNTRIES = ['fr', 'es', 'it', 'pt', 'de', 'us', 'gb']

const getF25Country = (country: string) => {
  if (LATAM_COUNTRIES.includes(country)) {
    return 'latam'
  }
  if (REGION_COUNTRIES.includes(country)) {
    return country
  }
  return 'world'
}

function getF25PlanPricing(addons: ChargebeeAddon[], country: string) {
  const areaAddons = addons.filter((addon) => {
    return addon.isF25Compatible(getF25Country(country))
  })

  // Group addons by period unit (month or year)
  const pricingAddon = areaAddons?.reduce(
    (acc, addon) => {
      if (addon.isPerSeat()) acc[addon.periodUnit].perSeat = addon
      if (addon.isFee()) acc[addon.periodUnit].fee = addon
      if (addon.isTiered()) acc[addon.periodUnit].tiered = addon
      if (addon.isStairstep()) acc[addon.periodUnit].stairstep = addon
      return acc
    },
    // eslint-disable-next-line no-type-assertion/no-type-assertion
    { month: {}, year: {} } as PricingType
  )

  if (!Object.keys(pricingAddon.month).length || !Object.keys(pricingAddon.year).length) return null

  return new Pricing(pricingAddon.month, pricingAddon.year)
}

export default getF25PlanPricing
